import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, FormGroup,
    Label, Input, Button, Row, Col
} from 'reactstrap';

import { AuthContext } from '../../context/AuthContext';
import { CursoContext } from '../../context/CursoContext';
import { CreateCursoType } from '../../context/hooks/useCurso';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onCursoCriado: () => void;
}

export const CreateCursoModal: React.FC<Props> = ({
    isOpen,
    toggle,
    onCursoCriado
}) => {
    const { objUserTk } = useContext(AuthContext);
    const { createCurso } = useContext(CursoContext);

    const defaultState: CreateCursoType = { name: '', empresaId: objUserTk.EmpresaId };
    const [form, setForm] = useState<CreateCursoType>(defaultState);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const reset = () => setForm(defaultState);

    useEffect(() => { if (isOpen) reset(); }, [isOpen]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const ok = await createCurso(form);
        if (ok) {
            onCursoCriado();
            toggle();       
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Adicionar novo curso</ModalHeader>

            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="name">Nome</Label>
                                <Input
                                    className="form-control-alternative"
                                    id="name"
                                    name="name"
                                    placeholder="Nome do curso"
                                    value={form.name}
                                    onChange={handleChange}
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end mt-4">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">
                            Criar curso
                        </Button>
                        <Button
                            style={{ background: '#d9534f', color: '#fff' }}
                            className="ml-2"
                            onClick={toggle}
                        >
                            Cancelar
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default CreateCursoModal;